module.exports = __webpack_public_path__ + "img/payslip-empty-image.09a1822e.webp";